var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { "padding-top": "30px" } }, [
    _vm.deal_id
      ? _c(
          "a",
          {
            staticClass: "btn btn-info btn-sm",
            staticStyle: {
              "margin-top": "-30px",
              "margin-bottom": "10px",
              background: "#20365F",
            },
            attrs: {
              href:
                "/account/users/general-partners/" +
                this.deal_id +
                "/sales-pipeline",
            },
          },
          [_vm._v("Back to the Pipeline")]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.is_loaded
      ? _c("div", [_vm._v("\n    The data is loading ...\n  ")])
      : _c("div", [
          _c("div", { staticClass: "pta-investor-profile-head" }, [
            _c("h1", [
              _vm._v(_vm._s(_vm.investor.name)),
              _c("br"),
              _vm._v("Investor Profile"),
            ]),
            _vm._v(" "),
            _c("img", { attrs: { src: "/images/logo_profile.svg" } }),
            _vm._v(" "),
            _c("ul", { staticClass: "mm-links" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "mm-link-pdf",
                    attrs: { href: "/ip/" + _vm.id + "/pdf" },
                  },
                  [_vm._v("PDF")]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pta-investor-profile" }, [
            _c("div", { staticClass: "pta-investor-profile-left" }, [
              _c("h2", [_vm._v("GENERAL INFORMATION")]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-investor-profile-box" }, [
                _c("h3", [_vm._v("DESCRIPTION")]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "pta-investor-profile-box-content",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.investor.description
                        ? _vm.investor.description
                        : "No information available."
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-investor-profile-box-2" }, [
                _c("h3", [_vm._v("INVESTOR TYPES")]),
                _vm._v(" "),
                _vm.investor.investor_types.length
                  ? _c(
                      "div",
                      { staticClass: "pta-investor-profile-box-content" },
                      _vm._l(
                        _vm.investor.investor_types,
                        function (investor_type) {
                          return _c("span", [_vm._v(_vm._s(investor_type))])
                        }
                      ),
                      0
                    )
                  : _c(
                      "div",
                      { staticClass: "pta-investor-profile-box-content" },
                      [
                        _vm._v(
                          "\n              No information available.\n            "
                        ),
                      ]
                    ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pta-investor-profile-box-2 pta-ml-40" },
                [
                  _c("h3", [_vm._v("ACTIVE")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pta-investor-profile-box-content" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.investor.active
                              ? _vm.investor.active
                              : "No information available."
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pta-clear-left" }),
              _vm._v(" "),
              _c("h2", [_vm._v("CONTACT INFORMATION")]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-investor-profile-box-2" }, [
                _c("h3", [_vm._v("PRIMARY CONTACT")]),
                _vm._v(" "),
                _vm.investor.contact_person
                  ? _c(
                      "div",
                      { staticClass: "pta-investor-profile-box-content" },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.investor.contact_person)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                  " + _vm._s(_vm.investor.cp_email)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                   " +
                            _vm._s(_vm.investor.website) +
                            "\n            "
                        ),
                      ]
                    )
                  : _c(
                      "div",
                      { staticClass: "pta-investor-profile-box-content" },
                      [
                        _vm._v(
                          "\n              No information available.\n            "
                        ),
                      ]
                    ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pta-investor-profile-box-2 pta-ml-40" },
                [
                  _c("h3", [_vm._v("PRIMARY OFFICE")]),
                  _vm._v(" "),
                  _vm.investor.hq_country ||
                  _vm.investor.hq_city ||
                  _vm.investor.hq_global_sub_region ||
                  _vm.investor.hq_global_region
                    ? _c(
                        "div",
                        { staticClass: "pta-investor-profile-box-content" },
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.investor.hq_city ? _vm.investor.hq_city : ""
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.investor.hq_country
                                  ? _vm.investor.hq_country
                                  : ""
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.investor.hq_global_sub_region
                                  ? _vm.investor.hq_global_sub_region
                                  : ""
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.investor.hq_global_region
                                  ? _vm.investor.hq_global_region
                                  : ""
                              ),
                            },
                          }),
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "pta-investor-profile-box-content" },
                        [
                          _vm._v(
                            "\n              No information available.\n            "
                          ),
                        ]
                      ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pta-investor-profile-right" }, [
              _c("h2", [_vm._v("INVESTMENT PREFERENCES")]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-investor-profile-box" }, [
                _c("h3", [_vm._v("POLICY DESCRIPTION")]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "pta-investor-profile-box-content",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.investor.policy_description
                        ? _vm.investor.policy_description
                        : "No information available."
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-investor-profile-box-2" }, [
                _c("h3", [_vm._v("PREFERRED COMMITMENT SIZE (USD MM)")]),
                _vm._v(" "),
                _c("div", { staticClass: "pta-investor-profile-box-content" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.investor.preferred_commitment_size
                          ? _vm.investor.preferred_commitment_size
                          : "No information available."
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pta-investor-profile-box-2 pta-ml-40" },
                [
                  _c("h3", [_vm._v("ASSETS UNDER MANAGEMENT (USD MM)")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pta-investor-profile-box-content" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.investor.assets_under_management
                              ? _vm.investor.assets_under_management
                              : "No information available."
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pta-investor-profile-box-2 pta-clear-left" },
                [
                  _c("h3", [_vm._v("GEOGRAPHICAL PREFERENCES")]),
                  _vm._v(" "),
                  _vm.investor.geos.length
                    ? _c(
                        "div",
                        { staticClass: "pta-investor-profile-box-content" },
                        _vm._l(_vm.investor.geos, function (geo) {
                          return _c("span", [_vm._v(_vm._s(geo))])
                        }),
                        0
                      )
                    : _c(
                        "div",
                        { staticClass: "pta-investor-profile-box-content" },
                        [
                          _vm._v(
                            "\n              No information available.\n            "
                          ),
                        ]
                      ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pta-investor-profile-box-2 pta-ml-40" },
                [
                  _c("h3", [_vm._v("PREFERRED ASSET CLASSES")]),
                  _vm._v(" "),
                  _vm.investor.asset_classes.length
                    ? _c(
                        "div",
                        { staticClass: "pta-investor-profile-box-content" },
                        _vm._l(
                          _vm.investor.asset_classes,
                          function (asset_class) {
                            return _c("span", [_vm._v(_vm._s(asset_class))])
                          }
                        ),
                        0
                      )
                    : _c(
                        "div",
                        { staticClass: "pta-investor-profile-box-content" },
                        [
                          _vm._v(
                            "\n              No information available.\n            "
                          ),
                        ]
                      ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pta-investor-profile-box-2 pta-clear-left" },
                [
                  _c("h3", [_vm._v("ESG STATUS")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pta-investor-profile-box-content" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.investor.esg_status
                              ? _vm.investor.esg_status
                              : "No information available."
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pta-investor-profile-box-2 pta-ml-40" },
                [
                  _c("h3", [_vm._v("INVESTMENT STRUCTURE")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pta-investor-profile-box-content" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.investor.investment_structure
                              ? _vm.investor.investment_structure
                              : "No information available."
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }